import { SerializedLayers } from "@lidojs/design-core";
import { RedirectionProps } from "./generateRedirectionHTML";
import { generateValidURL } from "./generateValidURL";

export function extractLinks(data: SerializedLayers): string {
  const links = {};

  Object.keys(data).forEach(key => {
    const layer = data[key];

    // links on components
    if ((layer.props?.hyperlink as RedirectionProps)?.hasHyperlink) {
      const hyperlink = layer.props?.hyperlink as RedirectionProps;
      const url = generateValidURL(hyperlink?.linkRedirect);
      if (key === 'ROOT' && hyperlink?.typeLink === 'click-tag') {
        links[key] = `%%CLICK_URL_UNESC%%${url}`;
      } else if (key === 'ROOT' && hyperlink?.typeLink === 'a-href') {
        links[key] = `{click_url:${url}}`;
      } else {
        links[key] = url;
      }
    }

    // links on carousel slides
    if (layer.type?.resolvedName === "CarouselLayer") {
      const carouselItems = layer.props?.itemsCarousel || [];
      if (Array.isArray(carouselItems)) {
        carouselItems.forEach((item, index) => {
          if (item.hasHyperlink) {
            links[item.id] = generateValidURL(item.linkRedirect);
          }
        });
      }
    }
  });

  return `
    const clickthrough = ${JSON.stringify(links)};
  `;
}
